import { api, unwrap } from '@/core/http';

export const identityApi = {
  /** Primeiro request após o login: provisiona o usuário (JIT) e devolve o perfil. */
  me: () => unwrap(api.GET('/v1/identity/me')),
  /**
   * "Criar conta": a API cria a conta no Keycloak e o registro do aluno. Não
   * devolve token — quem chama entra em seguida, com a mesma senha.
   */
  register: (body: { name: string; email: string; password: string }) =>
    unwrap(api.POST('/v1/auth/register', { body })),
};
